import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { generatePath } from 'react-router-dom';
import { Downgraded, useState } from '@hookstate/core';
import {
    Box,
    // CircularProgress,
    Slide,
} from '@mui/material';
import AdminNote from '../../sharedcomponents/adminNote/adminNote';
import { useAuthState } from '../../stores/authStore';
import { useEventState } from '../../stores/eventStore';
import RouteConstants from '../../constants/routeConstants';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import Helper from '../../utility/helper';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import StyledTableRow from '../../sharedcomponents/styledTable/styledTableRow';
import StyledTableCell from '../../sharedcomponents/styledTable/styledTableCell';
import PendingActionDialog from '../../sharedcomponents/confirmationdialog/pendingActionDialog';
import {
    NO_ACCESS_PERMISSION,
    FULL_PERMISSION,
    REQUEST_STATUS_LIST
} from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import AccordianCommonRequests from '../../sharedcomponents/commonRequest/accordianCommonRequest';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import StyledTable1 from '../../sharedcomponents/styledTable/styleTable1';
import AppConstants from '../../constants/appConstants';
import { isEmpty } from 'lodash-es';
import HotelSettingsDialog from '../../sharedcomponents/userList/hotelSettingsDialog';
import DataList from '../../sharedcomponents/dataList/dataList';

// const loader = {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     height: '100%',
//     width: '100%',
// };
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const headers = [
    { key: 'firstName', title: 'FirstName' },
    { key: 'lastName', title: 'LastName' },
    { key: 'email', title: 'Email' },
    { key: 'checkIn', title: 'Check In' },
    { key: 'checkOut', title: 'Check Out' },
    { key: 'hotelRoomTaxID', title: 'Room Type' },
    { key: 'roomTypeID', title: 'Bed Type' },
    { key: 'specialRequest', title: 'Special Request' },
    { key: 'shared', title: 'Shared' },
    { key: 'occupant', title: 'Occupants' },
    { key: 'submittedBy', title: 'Audit By' },
    { key: 'submittedDate', title: 'Audit Date' },
    { key: 'auditStatus', title: 'Audit Status' },
    { key: 'requestStatus', title: 'Status' },
];

const DraftHotelBooking = (props) => {
    const showSearch = true;
    const openDialog = useState(false);
    //const transittype = useState(null);

    const history = useHistory();
    const authState = useAuthState();
    const eventState = useEventState();
    const loading = useState(true);
    const allData = useState(null);
    const fullData = useState([]);
    const allListData = useState();
    const eventData = useState(null);
    const userID = useState(null);
    const [allNoteValue, setAllNoteValue] = React.useState('');
    const openNoteDialog = useState(false);
    const requestNote = useState(null);
    const requestPending = useState(null);
    const [showHistory, setShowHistory] = React.useState(false);
    const [hotelHistory, setHotelHistory] = React.useState();
    const [filterChangeVal, setFilterChangeVal] = React.useState(false);
    const [filters, setFilters] = React.useState(null);
    const statusList = useState(REQUEST_STATUS_LIST);
    const setAll = useState(false);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const filteredEmty = useState(false);
    const displayName = useState(null);
    const filteredList = useState([]);
    const [participantList, setParticipantList] = React.useState(null);
    const allNote = useState(false);
    const approveLoader = useState(false);
    const rejectLoader = useState(false)
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const approveConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const rejectConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: 5000,
        noOfPages: null,
    });

    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });

    const pendingAction = useState({
        open: false,
        title: '',
        message: '',
    });
    const approveloading = useState({
        loading: false,
        index: 0
    })
    const rejectloading = useState({
        loading: false,
        index: 0
    })
    const [modPermission, setModPermission] = React.useState(null);
    const [showStatus, setShowStatus] = React.useState({
        Approved: 0,
        Pending: 0,
        Rejected: 0,
    });
    const userInfo = Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');

    let eventRole = '';
    if (!isEmpty(eventInfo)) {
        eventRole =
            userInfo && userInfo.roles
                ? userInfo.roles.find(
                    (item) => item.eventID === eventInfo.eventID
                )?.eventRole
                : '';
    }

    useEffect(() => {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        if (
            userID.get() == null &&
            (eventData.get() == null ||
                (eventData.get() &&
                    eventData.eventID.value != eventInfo.eventID))
        ) {
            eventData.set(eventInfo);
            eventInfo.moduleDetails.filter((x) => x.moduleID === AppConstants.EVENT_MODULES.DRAFT_HOTEL).map((item) => {
                displayName.set(item.displayName)
            })
            userID.set(userInfo.userID);
        }

        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        ) {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: authStateInfo.itemsPerPage,
                noOfPages: null,
            });
        }
    }, [authState]);

    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState && eventState.eventDetail.get()) {
            if (
                Helper.isAdminUser(userInfo) ||
                Helper.isEventAdmin(userInfo) ||
                Helper.isEventStaff(userInfo)
            ) {
                setModPermission(FULL_PERMISSION);
            } else if (userInfo.roles) {
                const permissions = eventState.permissions
                    .attach(Downgraded)
                    .get();
                if (permissions && permissions.length > 0) {
                    setModPermission(
                        Helper.getModuleAccessPermission(
                            permissions,
                            'DRAFTHOTEL'
                        )
                    );
                }
            }
        }
    }, [eventState]);

    useEffect(() => {
        if (modPermission && modPermission != NO_ACCESS_PERMISSION) {
            const pageInfo = pagingInfo.attach(Downgraded).get();
            if (pageInfo.itemsPerPage) {
                getAdminHotelRequestList();
                getParticipantList();
            }
            getParticipantList();
        }
    }, [modPermission]);

    const getAdminHotelRequestList = () => {
        // console.log('ther');
        let participantList = [];
        const userInfo = Helper.getStorage('userInfo');
        loading.set(true);
        ApiHelper.get(
            APIURLConstants.GET_DRAFT_HOTELBOOKING_LIST(
                eventData.get().eventID,
                userInfo.userID,
                userInfo.userType == 'Admin' || !isEmpty(eventRole)
                    ? true
                    : false,
                false,
                1,
                5000
            )
        )
            .then((res) => {
                if (res.data.rows) {
                    let data = res.data.rows;
                    let allrequestData = [];
                    let requestData = [];
                    if (data.length > 0) {
                        let approved = 0;
                        let pending = 0;
                        let rejected = 0;
                        const indexOfLastRecord =
                            pagingInfo.get().currentPage *
                            pagingInfo.get().itemsPerPage;
                        const indexOfFirstRecord =
                            indexOfLastRecord - pagingInfo.get().itemsPerPage;
                        data.map((item) => {
                            if (item.requestStatus === 'Approved') {
                                approved += 1;
                            } else if (item.requestStatus === 'Pending') {
                                pending += 1;
                            } else {
                                rejected += 1;
                            }
                            if (
                                participantList.indexOf(item.participant) == -1
                            ) {
                                participantList.push(item.participant);
                            }
                            let hotelSettingData = [];
                            let hotelSettingRemainingcount = [];
                            if (
                                item.hotelAllStarSettings !== undefined &&
                                item.hotelAllStarSettings.length > 0
                            ) {
                                const parseData = JSON.parse(
                                    item.hotelAllStarSettings[0].setting
                                );
                                if (
                                    parseData !== undefined &&
                                    parseData.length > 0
                                ) {
                                    const settingParseData = JSON.parse(
                                        parseData[0].HotelSetting
                                    );
                                    // console.log(
                                    //     'settingParseData',
                                    //     settingParseData
                                    // );
                                    hotelSettingData.push(settingParseData);
                                    hotelSettingRemainingcount.push({
                                        comp:
                                            // Number(settingParseData.comp) -
                                            Number(
                                                item.hotelAllStarSettings[0]
                                                    .actualCompCount
                                            ),
                                        pay:
                                            // Number(settingParseData.pay) -
                                            Number(
                                                item.hotelAllStarSettings[0]
                                                    .actualPayCount
                                            ),
                                    });
                                }
                            }
                            allrequestData.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'checkbox',
                                        key: 'hotelBookID',
                                        hotelBookID: item.hotelBookID,
                                        width: '0.03',
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Participant',
                                        key: 'participant',
                                        participant: item.participant,
                                        width: '0.30',
                                        showLabel: false,
                                        toEmail: item.email,
                                        showEmail: true,
                                    },
                                    {
                                        label: 'Room Type',
                                        key: 'hotelRoom',
                                        hotelRoom: item.hotelRoomTax,
                                        hotelRoomValue: item.hotelRoomTaxID,
                                        width: '0.15',
                                        inColumn: true,
                                        showHotelToggle: true,
                                    },
                                    {
                                        label: 'Submitted By',
                                        key: 'createdBy',
                                        createdBy: item.createdByName,
                                        width: '0.20',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Submitted Date',
                                        key: 'createdDate',
                                        createdDate: !Helper.IfDateIsNULL(
                                            item.createdDate
                                        )
                                            ? Helper.FormatDate(
                                                item.createdDate
                                            )
                                            : '',
                                        width: '0.12',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'History',
                                        key: 'auditHistory',
                                        auditHistory: '',
                                        width: '0.05',
                                        showLabel: false,
                                        showChips: false,
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Shared',
                                        key: 'shared',
                                        shared: item.shared,
                                        width: '0.05',
                                        showSwitch: true,
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Allotment',
                                        key: 'allotment',
                                        hotelSettingData:
                                            hotelSettingData.length > 0
                                                ? hotelSettingData
                                                : 0,
                                        hotelSettingRemainingcount:
                                            hotelSettingRemainingcount.length >
                                                0
                                                ? hotelSettingRemainingcount
                                                : 0,
                                        allotment:
                                            hotelSettingData.length > 0
                                                ? hotelSettingData[0].comp +
                                                '/' +
                                                hotelSettingData[0].pay +
                                                '|' +
                                                hotelSettingData[0].comp +
                                                '/' +
                                                hotelSettingData[0].pay
                                                : 0,
                                        showLabel: false,
                                        width: '0.10',
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Status',
                                        key: 'requestStatus',
                                        requestStatus: item.requestStatus,
                                        width: '0.05',
                                        showStatusIcon: true,
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'All',
                                        all: 'All',
                                        width: '0.15',
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                ],
                                selected: false,                                
                                expanded: false,
                            });
                        });
                        fullData.set(allrequestData);
                        setFilters({
                            participant: participantList,
                            requestStatus: statusList.attach(Downgraded).get(),
                        });
                        data.slice(indexOfFirstRecord, indexOfLastRecord).map(
                            (item) => {
                                // console.log('item', item);

                                let hotelSettingData = [];
                                let hotelSettingRemainingcount = [];
                                if (
                                    item.hotelAllStarSettings !== undefined &&
                                    item.hotelAllStarSettings.length > 0
                                ) {
                                    const parseData = JSON.parse(
                                        item.hotelAllStarSettings[0].setting
                                    );
                                    if (
                                        parseData !== undefined &&
                                        parseData.length > 0
                                    ) {
                                        const settingParseData = JSON.parse(
                                            parseData &&
                                            parseData[0].HotelSetting
                                        );

                                        hotelSettingData.push(settingParseData);
                                        hotelSettingRemainingcount.push({
                                            comp:
                                                //Number(settingParseData.comp) -
                                                Number(
                                                    item.hotelAllStarSettings[0]
                                                        .actualCompCount
                                                ),
                                            pay:
                                                // Number(settingParseData.pay) -
                                                Number(
                                                    item.hotelAllStarSettings[0]
                                                        .actualPayCount
                                                ),
                                        });
                                    }
                                }
                                // console.log(
                                //     'hotelSettingData',
                                //     hotelSettingRemainingcount,
                                //     hotelSettingData,
                                //     item.hotelAllStarSettings
                                // );
                                requestData.push({
                                    actualData: item,
                                    row: [
                                        {
                                            label: 'checkbox',
                                            key: 'hotelBookID',
                                            hotelBookID: item.hotelBookID,
                                            width: '0.03',
                                            inColumn: true,
                                            alignCenter: true,
                                        },
                                        {
                                            label: 'Participant',
                                            key: 'participant',
                                            participant: item.participant,
                                            width: '0.30',
                                            showLabel: false,
                                            toEmail: item.email,
                                            showEmail: true,
                                        },
                                        {
                                            label: 'Room Type',
                                            key: 'hotelRoom',
                                            hotelRoom: item.hotelRoomTax,
                                            hotelRoomValue: item.hotelRoomTaxID,
                                            width: '0.15',
                                            inColumn: true,
                                            showHotelToggle: true,
                                            // asList: true,
                                            // alignCenter: true,
                                        },
                                        {
                                            label: 'Submitted By',
                                            key: 'createdBy',
                                            createdBy: item.createdByName,
                                            width: '0.20',
                                            inColumn: true,
                                        },
                                        // {
                                        //     label: 'Check In',
                                        //     key: 'checkIn',
                                        //     checkIn: Helper.FormatDate(item.checkIn),
                                        //     width: '0.15',
                                        // },
                                        // {
                                        //     label: 'Check Out',
                                        //     key: 'checkOut',
                                        //     checkOut: Helper.FormatDate(item.checkOut),
                                        //     width: '0.15',
                                        // },
                                        {
                                            label: 'Submitted Date',
                                            key: 'createdDate',
                                            createdDate: !Helper.IfDateIsNULL(
                                                item.createdDate
                                            )
                                                ? Helper.FormatDate(
                                                    item.createdDate
                                                )
                                                : '',
                                            width: '0.12',
                                            inColumn: true,
                                        },
                                        // {
                                        //     label: 'Modified On',
                                        //     key: 'modifiedDate',
                                        //     modifiedDate: !Helper.IfDateIsNULL(
                                        //         item.modifiedDate
                                        //     )
                                        //         ? Helper.FormatDate(
                                        //             item.modifiedDate
                                        //         ) +
                                        //         ' ' +
                                        //         Helper.FormatTime(
                                        //             item.modifiedDate
                                        //         )
                                        //         : '',
                                        //     width: '0.25',
                                        //     inColumn: true,
                                        // },
                                        {
                                            label: 'History',
                                            key: 'auditHistory',
                                            auditHistory: '',
                                            width: '0.05',
                                            showLabel: false,
                                            showChips: false,
                                            inColumn: true,
                                        },
                                        {
                                            label: 'Shared',
                                            key: 'shared',
                                            shared: item.shared,
                                            width: '0.05',
                                            showSwitch: true,
                                            inColumn: true,
                                            alignCenter: true,
                                        },
                                        {
                                            label: 'Allotment',
                                            key: 'allotment',
                                            hotelSettingData:
                                                hotelSettingData.length > 0
                                                    ? hotelSettingData
                                                    : 0,
                                            hotelSettingRemainingcount:
                                                hotelSettingRemainingcount.length >
                                                    0
                                                    ? hotelSettingRemainingcount
                                                    : 0,
                                            allotment:
                                                hotelSettingData.length > 0
                                                    ? hotelSettingData[0].comp +
                                                    '/' +
                                                    hotelSettingData[0].pay +
                                                    '|' +
                                                    hotelSettingData[0].comp +
                                                    '/' +
                                                    hotelSettingData[0].pay
                                                    : 0,
                                            showLabel: false,
                                            width: '0.15',
                                            alignCenter: true,
                                        },

                                        {
                                            label: 'Status',
                                            key: 'requestStatus',
                                            requestStatus: item.requestStatus,
                                            width: '0.05',
                                            showStatusIcon: true,
                                            inColumn: true,
                                            alignCenter: true,
                                        },

                                        {
                                            label: 'Action',
                                            key: 'All',
                                            all: 'All',
                                            width: '0.15',
                                            inColumn: true,
                                            alignCenter: true,
                                        },
                                    ],
                                    selected: false,
                                    expanded: false,
                                });
                            }
                        );
                        setShowStatus({
                            Approved: approved,
                            Pending: pending,
                            Rejected: rejected,
                        });
                    }
                    setShowSearchRec(false);
                    let filterData = filteredList.attach(Downgraded).get();
                    if (filterData.length > 0) {
                        setFilterChangeVal(false);
                    }
                    allData.set(requestData);
                    allListData.set(requestData);
                    loading.set(false);

                    if (pagingInfo.get().noOfPages == null) {
                        pagingInfo.set({
                            ...pagingInfo,
                            currentPage: pagingInfo.get().currentPage,
                            itemsPerPage: pagingInfo.get().itemsPerPage,
                            noOfPages: Math.ceil(
                                data.length / pagingInfo.get().itemsPerPage
                            ),
                        });
                    }
                }
            })
            .catch((error) => {
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    alert(error);
                }
            });
    };

    const onSharedVendor = (isChecked, hotelBookID, userID) => {
        const updateShared = {
            HotelBookID: hotelBookID,
            Shared: isChecked,
            Status: -1,
            ModifiedBy: userID,
        };
        ApiHelper.post(
            APIURLConstants.POST_STATUS_OR_SHARE_DRAFT_HOTEL,
            updateShared
        )
            .then(async (res) => {
                if (res.data) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request updated successfully',
                    });
                    loading.set(false);
                }
            })
            .catch((error) => {
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Access denied',
                    });
                } else {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Error while creating request',
                    });
                }
            });
    };

    const callExport = () => {
        // const gridData = allData.get();
        // if (gridData.length > 0) {
        const selected = !filteredEmty.get() && filteredList.get() && filteredList.get().length > 0
            ? filteredList.get().filter((x) => x.selected === true) :
            allData.get().filter((user) => user.selected === true);
        if (selected.length > 0) {
            const allSelected = fullData
                .get()
                .filter((user) => user.selected === false);

            if (selected.length === 0) {
                generateExcelReport(allSelected);
            } else {
                generateExcelReport(selected);
            }
        } else {
            const selected = allData
                .get()
                .filter((user) => user.selected === true);
            const allSelected = fullData
                .get()
                .filter((user) => user.selected === false);

            if (selected.length === 0) {
                generateExcelReport(allSelected);
            } else {
                generateExcelReport(selected);
            }
        }
        // }
        // else
        // {
        //     setSnackBarProps({
        //         ...snackBarProps,
        //         openSnack: true,
        //         variant: 'error',
        //         message: 'Please add request first.',
        //     });
        // }
    };

    const handleConfirmation = () => {
        let deleteRequests = [];
        allData.get().map((row) => {
            if (row.selected === true) {
                deleteRequests.push(row.actualData.hotelBookID);
            }
        });
        fullData.get().map((row) => {
            if (row.selected === true) {
                deleteRequests.push(row.actualData.hotelBookID);
            }
        });

        ApiHelper.post(APIURLConstants.DELETE_DRAFTHOTELBOOKING, {
            Ids: deleteRequests.join(','),
            SoftDelete: true,
            ModifiedBy: userID.value,
        })
            .then((res) => {
                if (res.data) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request deleted successfully',
                    });
                    //props.onDelete(false);
                    setAll.set(false);
                    getAdminHotelRequestList();
                }
            })
            .catch((error) => {
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };

    const handlePendingAction = () => {
        pendingAction.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
        const req = requestPending.attach(Downgraded).get();
        const updateShared = {
            HotelBookID: req.hotelBookID,
            Shared: -1,
            Status: req.status,
            ModifiedBy: req.userID,
        };
        ApiHelper.post(
            APIURLConstants.POST_STATUS_OR_SHARE_DRAFT_HOTEL,
            updateShared
        ).then((res) => {
            if (res.data) {
                rejectloading.set({
                    loading: false,
                    index: 0
                })
                approveloading.set({
                    loading: false,
                    index: 0
                })
                pendingAction.set({
                    open: false,
                    title: '',
                    OkButtonText: 'Ok',
                    message: '',
                });
                requestPending.set(null);
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'success',
                    message: 'Request updated successfully',
                });
                getAdminHotelRequestList();
                let published = {}
                participantList.filter((item) => item.userID === req.addedFor).map((x) => {
                    published = { isPublished: x.isPublished }
                })
                //                 if(published.isPublished){
                // getEmailNotification(req.hotelBookID);
                //                 }
            }
        });
    };

    const generateExcelReport = async (result) => {
        let selectedIds = [];
        let HotelBookingIDs = null;
        if (result.length > 0) {
            result.map((item) => {
                selectedIds.push(item.actualData.hotelBookID);
            });
            HotelBookingIDs = selectedIds.join(',');
        }

        await ApiHelper.post(
            APIURLConstants.GET_MEExport, {
            eventID: eventData.get().eventID,
            moduleID: 22,
            IDs: HotelBookingIDs
        }
        ).then((res) => {
            const finalObject = JSON.parse(res.data.value);
            if (finalObject) {
                if (finalObject.length > 0) {
                    let header = {};
                    Object.keys(finalObject[0]).map((key) => {
                        header[key] = key;
                    });

                    finalObject.unshift(header);
                    Helper.downloadReport(finalObject, `HotelBooking-Report`);
                }
                // else {
                //     // setSnackBarProps({
                //     //     ...snackBarProps,
                //     //     openSnack: true,
                //     //     variant: 'error',
                //     //     message: 'Please add mapping for this event.',
                //     // });
                // }
            }
            // else {
            //     setSnackBarProps({
            //         ...snackBarProps,
            //         openSnack: true,
            //         variant: 'error',
            //         message: 'Please add mapping for this event.',
            //     });
            // }
        });
    };

    const handlePageChange = (event, page) => {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
        getAdminHotelRequestList();
    };

    const onSwitchToggle = (event, findex, item) => {
        let newData = allData.attach(Downgraded).get();
        let index = newData.findIndex(
            (data) => data.actualData.hotelBookID == item.actualData.hotelBookID
        );
        let newItem = newData[index];
        newItem.actualData.shared = event.target.checked;
        const shareIndex = newItem.row.findIndex((rw) => rw.key == 'shared');

        newItem.row[shareIndex].shared = event.target.checked;
        allData[index].set(newItem);
        const isChecked = event.target.checked ? 1 : 0;

        onSharedVendor(isChecked, item.actualData.hotelBookID, userID.get());
    };

    const onToggleChange = (item, findex) => {
        item.expanded = !item.expanded;

        let index = allData.findIndex(i => i.actualData.hotelBookID === item.actualData.hotelBookID);
        allData[index].set(item);

        let newIndex = fullData.findIndex(i => i.actualData.hotelBookID === item.actualData.hotelBookID);
        fullData[newIndex].set(item);
    }

    const onActionClick = (item, index, action) => {
        if (action == 'Approve') {
            approveloading.set({
                loading: true,
                index: index
            })
        }
        else if (action == 'Reject') {
            rejectloading.set({
                loading: true,
                index: index
            })
        }
        let newData = [...allData.attach(Downgraded).get()];
        let Index = newData.findIndex(
            (data) => data.actualData.hotelBookID == item.actualData.hotelBookID
        );
        let newItem = newData[Index];

        const isStatus = action == 'Approve' ? 2 : action == 'Reject' ? 3 : 1;
        requestNote.set({
            hotelBookID: newItem.actualData.hotelBookID,
            status: isStatus,
            userID: userID.get(),
            action,
            note: newItem.note,
            item: newItem.actualData,
        });
        openNoteDialog.set(true);
    };

    const closeNoteDialog = () => {
        approveloading.set({
            loading: false,
            index: 0
        })
        rejectloading.set({
            loading: false,
            index: 0
        })
        openNoteDialog.set(false);
        requestNote.set(null);
    };
    const renderDialogContent = () => {
        return <StyledTable1 rowHeader={headers} data={hotelHistory} />;
    };

    const renderDialogActions = () => { };
    const getHotelHistory = (id) => {
        ApiHelper.get(APIURLConstants.GET_DRAFT_HOTEL_HISTORY(id)).then(
            (res) => {
                // console.log(res.data)

                setHotelHistory([]);
                let arr = [];

                let result = res.data.reduce(function (r, c) {
                    r[c.hotelBookAuditID] = r[c.hotelBookAuditID] || {
                        hotelBookAuditID: c.hotelBookAuditID,
                        participant: c.participant,
                        email: c.email,
                        checkIn: c.checkIn,
                        checkOut: c.checkOut,
                        hotelRoomTaxID: c.hotelRoomTaxID,
                        roomTypeID: c.roomTypeID,
                        specialRequest: c.specialRequest,
                        shared: c.shared,
                        submittedBy: c.submittedBy,
                        submittedDate: c.submittedDate,
                        auditStatus: c.auditStatus,
                        requestStatus: c.requestStatus,
                        occupants: c.occupantList,
                    };
                    // r[c.hotelBookAuditID].occupants.push({
                    //     occupant: c.occupantList ? c.occupantList : '',
                    // });
                    return r;
                }, {});

                Object.values(result).map((item, index, originalArr) => {
                    let previous = originalArr[index - 1];
                    arr.push({
                        actualData: item,
                        row: [
                            {
                                firstName: item.participant.split(', ')[1],
                                highlight:
                                    index > 0
                                        ? previous?.participant !==
                                            item.participant
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                lastName: item.participant.split(', ')[0],
                                highlight:
                                    index > 0
                                        ? previous?.participant !==
                                            item.participant
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                email: item.email,
                                highlight:
                                    index > 0
                                        ? previous?.email !== item.email
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                checkIn: Helper.FormatDate(item.checkIn),
                                highlight:
                                    index > 0
                                        ? previous?.checkIn !== item.checkIn
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                checkOut: Helper.FormatDate(item.checkOut),
                                highlight:
                                    index > 0
                                        ? previous?.checkOut !== item.checkOut
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                hotelRoomTaxID: item.hotelRoomTaxID,
                                highlight:
                                    index > 0
                                        ? previous?.hotelRoomTaxID !==
                                            item.hotelRoomTaxID
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                roomTypeID: item.roomTypeID,
                                highlight:
                                    index > 0
                                        ? previous?.roomTypeID !==
                                            item.roomTypeID
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                specialRequest: item.specialRequest,
                                highlight:
                                    index > 0
                                        ? previous?.specialRequest !==
                                            item.specialRequest
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                shared: item.shared === true ? 'Yes' : 'No',
                                highlight:
                                    index > 0
                                        ? previous?.shared !== item.shared
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                occupant:
                                    item.occupants //&& item.occupants.length > 0
                                        ? item.occupants
                                        // .map((x) => `${x.occupant} `)
                                        // .join(',')
                                        : '',
                                highlight:
                                    index > 0
                                        ? previous?.occupants !== item.occupants
                                            ? true
                                            : false
                                        : false,
                            },

                            {
                                submittedBy: item.submittedBy
                                    ? item.submittedBy
                                    : '',
                                highlight:
                                    index > 0
                                        ? previous?.submittedBy !==
                                            item.submittedBy
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                submittedDate: item.submittedDate
                                    ? Helper.FormatDateTime(item.submittedDate)
                                    : '',
                                highlight:
                                    index > 0
                                        ? previous?.submittedDate !==
                                            item.submittedDate
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                auditStatus: item.auditStatus
                                    ? item.auditStatus
                                    : '',
                                highlight:
                                    index > 0
                                        ? previous?.auditStatus !==
                                            item.auditStatus
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                requestStatus: item.requestStatus
                                    ? item.requestStatus
                                    : '',
                                highlight:
                                    index > 0
                                        ? previous?.requestStatus !==
                                            item.requestStatus
                                            ? true
                                            : false
                                        : false,
                            },
                        ],
                    });
                });
                setHotelHistory(arr);
            }
        );
    };
    const showHotelHistory = (item) => {
        setShowHistory(true);
        getHotelHistory(item.actualData.hotelBookID);
    };
    const getParticipantList = () => {
        const gUserInfo = Helper.getStorage('userInfo');
        const gEventInfo = Helper.getStorage('eventInfo');
        if (
            Helper.isAdminUser(gUserInfo) ||
            (gUserInfo.roles && Helper.isEventAdmin(gUserInfo)) ||
            (gUserInfo.roles && Helper.isEventStaff(gUserInfo))
        ) {
            ApiHelper.get(
                APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
            ).then((res) => {
                if (res.data.rows) {
                    const participants = res.data.rows.filter(
                        (participant) =>
                            AppConstants.EVENT_ROLES_VALUES.indexOf(
                                participant.roleName
                            ) == -1
                    );
                    setParticipantList(participants);
                }
            });
        }
    };

    const updateNote = async (value) => {
        const gEventInfo = Helper.getStorage('eventInfo');
        let newRequestNote = { ...requestNote.attach(Downgraded).get() };
        newRequestNote['note'] = value;
        newRequestNote['item'].note = value;

        const statusUpdate = {
            HotelBookID: newRequestNote.hotelBookID,
            Status: newRequestNote.status,
            Shared: -1,
            ModifiedBy: newRequestNote.userID,
        };
        const notesUpdate = {
            HotelBookID: newRequestNote.hotelBookID,
            Note: newRequestNote.note,
            ModifiedBy: newRequestNote.userID,
            EventID: gEventInfo.eventID
        };

        ApiHelper.post(
            APIURLConstants.POST_STATUS_OR_SHARE_DRAFT_HOTEL,
            statusUpdate
        )
            .then((result) => {
                if (result.data) {
                    ApiHelper.post(
                        APIURLConstants.POST_DRAFT_HOTELBOOKING_NOTE,
                        notesUpdate
                    )
                        .then(async (res) => {
                            if (res.data) {
                                approveloading.set({
                                    loading: false,
                                    index: 0
                                })
                                rejectloading.set({
                                    loading: false,
                                    index: 0
                                })
                                setSnackBarProps({
                                    ...snackBarProps,
                                    openSnack: true,
                                    variant: 'success',
                                    message: 'Status updated successfully',
                                });
                                let published = {}
                                participantList.filter((item) => item.userID === newRequestNote.item.addedFor).map((x) => {
                                    published = { isPublished: x.isPublished }
                                })
                                // if(published.isPublished){
                                // await getEmailNotification(
                                //     newRequestNote.hotelBookID
                                // );
                                // }
                                await getAdminHotelRequestList();
                                if (eventData.get().readonlyOrHide === 0 && published.isPublished) {
                                    await saveAppNotification(newRequestNote);
                                }
                                await closeNoteDialog();
                            }
                        })
                        .catch((err) => {
                            approveloading.set({
                                loading: false,
                                index: 0
                            })
                            rejectloading.set({
                                loading: false,
                                index: 0
                            })
                            console.log(err);
                        });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const saveAppNotification = (obj) => {
        let payLoad = {
            appNotificationID: 0,
            userIDs: JSON.stringify(obj.item.addedFor),
            appNotificationTypeID: 1,
            eventID: eventData.get().eventID,
            moduleID: 22,
            recordRefID: obj.hotelBookID,
            requestStatus: obj.status,
            status: 0,
            createdBy: userID.get(),
        };
        ApiHelper.post(APIURLConstants.SAVE_APP_NOTIFICATION, payLoad)
            .then(() => {
                // console.log(res);
                ApiHelper.get(
                    APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
                        obj.item.addedFor,
                        eventData.get().eventID,
                        eventData.get().eventName,
                        displayName.get(),
                        obj.status === 2
                            ? 'Approved'
                            : obj.status === 3
                                ? 'Rejected'
                                : 'Pending'
                    )
                ).then((res) => {
                    // console.log(res);
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    //// After Completed New Request Page Then Un Commet
    const redirectToEditHotelRequest = (data) => {
        const row = data.actualData;
        let registeredIds = allData
            .attach(Downgraded)
            .get()
            .map((x) => x.actualData.addedFor);
        let index = registeredIds.indexOf(row.addedFor);
        registeredIds.splice(index, 1);
        // let filteredParticipants = participantList.filter(
        //     (x) => !registeredIds.includes(x.userID)
        // );
        const path = generatePath(RouteConstants.EDIT_DRAFT_HOTEL_EVENT, {
            eventID: eventData.get().eventID,
            hotelBookingID: row.hotelBookID,
        });

        history.push({
            pathname: path,
            state: {
                hotelState: row,
                participantList: participantList,
                admin: true,
            },
        });
    };

    const onAddRequest = () => {
        // let registeredIds = allData
        //     .attach(Downgraded)
        //     .get()
        //     .map((x) => x.actualData.addedFor);
        // let filteredParticipants = participantList.filter(
        //     (x) => !registeredIds.includes(x.userID)
        // );
        history.push({
            pathname: generatePath(RouteConstants.CREATE_DRAFT_EVENT_HOTEL, {
                eventID: eventData.get().eventID,
            }),
            state: {
                hotel: '',
                participantList: participantList,
                admin: true,
            },
        });
        // openDialog.set(true);
    };
    const filterListData = (data) => {
        if (data.length == 0) {
            filteredEmty.set(true);
        } else {
            filteredEmty.set(false);
        }
        filteredList.set(data);
    };
    const onDelete = () => {
        const selected = allData.get().filter((user) => user.selected === true);
        const selected1 = fullData
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to delete all request?'
                : 'Do you want to delete selected request?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const onPendingAction = (item, index) => {
        if (item.actualData.requestStatus == 'Approved') {
            approveloading.set({
                loading: true,
                index: index
            })
        }
        else if (item.actualData.requestStatus == 'Rejected') {
            rejectloading.set({
                loading: true,
                index: index
            })
        }
        let newData = [...allData.attach(Downgraded).get()];
        let Index = newData.findIndex(
            (data) => data.actualData.hotelBookID == item.actualData.hotelBookID
        );
        let newItem = newData[Index].actualData;

        const isStatus = 1;
        requestPending.set({
            addedFor: newItem.addedFor,
            status: isStatus,
            userID: userID.get(),
            hotelBookID: newItem.hotelBookID,
        });

        let message = 'Do you want to move request to pending?';

        pendingAction.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: message,
        });
    };
    // const getEmailNotification = async (hotelBookID) => {
    //     const gUserInfo = Helper.getStorage('userInfo');
    //     await ApiHelper.get(
    //         APIURLConstants.GET_DRAFT_HOTEL_BOOK_MASTER(
    //             eventInfo.eventID,
    //             hotelBookID
    //         )
    //     ).then((res) => {
    //         if (res.data) {
    //             let form = new FormData();
    //             form.append('UserID', res.data.userID);
    //             form.append('EventID', res.data.eventID);
    //             form.append('TemplateType', 'DraftHotelReservation');
    //             form.append('ID', res.data.id);
    //             form.append('ModifyBy', gUserInfo.userID);
    //             form.append('TranportType', 'DraftHotelReservation');
    //             form.append('ModuleID', 22);

    //             return ApiHelper.post(
    //                 APIURLConstants.POST_EMAIL_NOTIFICATION,
    //                 form
    //             )
    //                 .then((result) => {
    //                     return result.data;
    //                 })
    //                 .catch((err) => {
    //                     console.log(err);
    //                 });
    //         }
    //     });
    // };
    // const getMultiEmailNotification = async (multiUsers, requestIds) => {
    //     // console.log(multiUsers)

    //     multiUsers.map((user, index) => {
    //         let form = new FormData();
    //         form.append('UserID', user);
    //         form.append('EventID', eventInfo.eventID);
    //         form.append('TemplateType', 'DraftHotelReservation');
    //         form.append('ID', requestIds[index]);
    //         form.append('ModifyBy', userID.value);
    //         form.append('TranportType', 'DraftHotelReservation');
    //         form.append('ModuleID', 22);
    //         return ApiHelper.post(APIURLConstants.POST_EMAIL_NOTIFICATION, form)
    //             .then((result) => {
    //                 return result.data;
    //             })
    //             .catch((err) => {
    //                 console.log(err);
    //             });
    //     });
    // };
    const multiApprove = () => {
        const selected = allData.get().filter((user) => user.selected === true);
        const selected1 = fullData
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to Approve all request?'
                : 'Do you want to Approve selected request?';

            approveConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const multiReject = () => {
        const selected = allData.get().filter((user) => user.selected === true);
        const selected1 = fullData
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to Reject all request?'
                : 'Do you want to Reject selected request?';
            allNote.set(true);
            rejectConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const hanldeAllNoteValue = (item) => {
        setAllNoteValue(item);
    };
    // const multisaveAppNotification = (multiUsers, requestIds, status) => {
    //     multiUsers.map((user, index) => {
    //         let payLoad = {
    //             appNotificationID: 0,
    //             userIDs: JSON.stringify(user),
    //             appNotificationTypeID: 1,
    //             eventID: eventData.get().eventID,
    //             moduleID: 22,
    //             recordRefID: requestIds[index],
    //             requestStatus: status,
    //             status: 0,
    //             createdBy: userID.get(),
    //         };
    //         ApiHelper.post(APIURLConstants.SAVE_APP_NOTIFICATION, payLoad)
    //             .then(() => {
    //                 // console.log(res);
    //                 ApiHelper.get(
    //                     APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
    //                         user,
    //                         eventData.get().eventID,
    //                         eventData.get().eventName,
    //                         'PlayerHotel',
    //                         status === 2
    //                             ? 'Approved'
    //                             : status === 3
    //                             ? 'Rejected'
    //                             : 'Pending'
    //                     )
    //                 ).then((res) => {
    //                     console.log(res);
    //                 });
    //             })
    //             .catch((err) => {
    //                 console.log(err);
    //             });
    //     });
    // };
    const handleRejectConfirmation = () => {
        let rejectRequests = [];
        // let multiUsers = [];
        allData.get().map((row) => {
            if (row.selected === true) {
                rejectRequests.push({
                    userID: row.actualData.addedFor,
                    iD: row.actualData.hotelBookID,
                    transportType: 'DraftHotelReservation',
                });
                // multiUsers.push(row.actualData.addedFor);
            }
        });
        fullData.get().map((row) => {
            if (row.selected === true) {
                rejectRequests.push({
                    userID: row.actualData.addedFor,
                    iD: row.actualData.hotelBookID,
                    transportType: 'DraftHotel',
                });
                // multiUsers.push(row.actualData.addedFor);
            }
        });
        rejectLoader.set(true)
        ApiHelper.post(APIURLConstants.UPDATE_MULTI_SELECT_STATUS, {
            Ids: JSON.stringify(rejectRequests), //rejectRequests.join(','),
            Status: 3,
            Note: allNoteValue,
            EventID: eventInfo.eventID,
            ModuleID: 22,
            ModifiedBy: userID.value,
            TemplateType: 'DraftHotel',
            TransportType: 'DraftHotel',
            appNotificationTypeID: 1,
        })
            .then((res) => {
                if (res.data) {
                    rejectLoader.set(false)
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request rejected successfully',
                    });
                    setAll.set(false);
                    setAllNoteValue("")
                    getAdminHotelRequestList();
                    // getMultiEmailNotification(multiUsers, rejectRequests);
                    // if (eventData.get().readonlyOrHide === 0) {
                    //     multisaveAppNotification(multiUsers, rejectRequests, 3);
                    // }
                }
            })
            .catch((error) => {
                rejectLoader.set(false)
                if (error.response && error.response.status === 401) {
                    let message = 'Access denied';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                } else if (error.response && error.response.status === 502) {
                    let message = 'Request rejected successfully';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: message,
                    });
                } else {
                    let message = 'Error while reject request';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                }
            });
        rejectConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const handleApproveConfirmation = () => {
        let approveRequests = [];
        // let multiUsers = [];
        allData.get().map((row) => {
            if (row.selected === true) {
                approveRequests.push({
                    userID: row.actualData.addedFor,
                    iD: row.actualData.hotelBookID,
                    transportType: 'DraftHotelReservation',
                });
                //multiUsers.push(row.actualData.addedFor);
            }
        });
        fullData.get().map((row) => {
            if (row.selected === true) {
                approveRequests.push({
                    userID: row.actualData.addedFor,
                    iD: row.actualData.hotelBookID,
                    transportType: 'DraftHotel',
                });
            }
        });
        approveLoader.set(true)
        ApiHelper.post(APIURLConstants.UPDATE_MULTI_SELECT_STATUS, {
            Ids: JSON.stringify(approveRequests),
            Status: 2,
            Note: allNoteValue,
            EventID: eventInfo.eventID,
            ModuleID: 22,
            ModifiedBy: userID.value,
            TemplateType: 'DraftHotel',
            TransportType: 'DraftHotel',
            appNotificationTypeID: 1,
        })
            .then((res) => {
                if (res.data) {
                    approveLoader.set(false)
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request approved successfully',
                    });
                    setAll.set(false);
                    setAllNoteValue("")
                    getAdminHotelRequestList();
                    // getMultiEmailNotification(multiUsers, approveRequests);
                    // if (eventData.get().readonlyOrHide === 0) {
                    //     multisaveAppNotification(
                    //         multiUsers,
                    //         approveRequests,
                    //         2
                    //     );
                    // }
                }
            })
            .catch((error) => {
                approveLoader.set(false)
                if (error.response && error.response.status === 401) {
                    let message = 'Access denied';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                } else if (error.response && error.response.status === 502) {
                    let message = 'Request approved successfully';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: message,
                    });
                } else {
                    let message = 'Error while approve request';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                }
            });
        approveConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const onSettingClick = () => {
        openDialog.set(true);
    };
    const handleClose = () => {
        openDialog.set(false);
    };

    const generateAgentRoomExcelReport = async (result) => {

        await ApiHelper.post(
            APIURLConstants.Excel_Export, {
            EventID: eventData.get().eventID,
            ModuleID: AppConstants.EVENT_MODULES.DRAFT_HOTEL,
            IDs: ''
        }
        ).then((res) => {
            const finalObject = JSON.parse(res.data.value);
            if (finalObject) {
                if (finalObject.length > 0) {
                    let header = {};
                    Object.keys(finalObject[0]).map((key) => {
                        header[key] = key;
                    });

                    finalObject.unshift(header);
                    Helper.downloadReport(finalObject, `AgentRoomHotelBooking-Report`);
                }
            }
        });
    }


    return (
        <Box className={"virtusoSummaryContentBox"}>
            {
                // loading.get() ? (
                //     <Box style={loader}>
                //         <CircularProgress />
                //     </Box>
                // ) :
                modPermission && modPermission == NO_ACCESS_PERMISSION ? (
                    <UnauthorizedUI showLogout={false} />
                ) : (
                    <DataList
                        // new props
                        data={allData.attach(Downgraded).get()}
                        allData={fullData.attach(Downgraded).get()}
                        editRow={redirectToEditHotelRequest}
                        handleClick={onAddRequest}
                        title={''}
                        //showYesNoCount={true}
                        buttonTitle={'Add'}
                        deleteRows={onDelete}
                        showSearch={showSearch}
                        filterChangeVal={filterChangeVal}
                        loading={loading.get()}
                        searchLabel={'Search'}
                        showFilter={true}
                        filters={filters}
                        showSearchRec={showSearchRec}
                        setShowSearchRec={setShowSearchRec}
                        onSwitchToggle={onSwitchToggle}
                        onActionClick={onActionClick}
                        showSync={true}
                        showHistory={showHotelHistory}
                        showExport={true}
                        callExport={callExport}
                        getResults={getAdminHotelRequestList}
                        pagingInfo={pagingInfo.attach(Downgraded).get()}
                        handlePageChange={handlePageChange}
                        isPage={true}
                        snackBarProps={snackBarProps}
                        setSnackBarProps={setSnackBarProps}
                        onPendingAction={onPendingAction}
                        modPermission={modPermission}
                        filterListData={filterListData}
                        moduleToShow={'Player Hotel'}
                        moduleDisplayName={Helper.getModuleName(eventData.get() ? eventData.get().moduleDetails : [],
                            AppConstants.EVENT_MODULES.DRAFT_HOTEL)}
                        showRequestStatus={showStatus}
                        multiApprove={multiApprove}
                        multiReject={multiReject}
                        showApproveAndReject={true}
                        onSettingClick={onSettingClick}
                        approveLoader={approveLoader.get()}
                        rejectLoader={rejectLoader.get()}
                        approveloading={approveloading.get()}
                        rejectloading={rejectloading.get()}
                        windowAccordDataList={true}
                        rowType='combinehotel'
                        onToggleChange={onToggleChange}
                        // showAgentRoomExport={true}
                        callAgentRoomExport={generateAgentRoomExcelReport}
                        windowDataList={true} 
                        hideReject={true}
                        hideApprove={true}
                        moduleVirtusoDataList={true}
                        showVirtusoSelectAll={true}
                    />
                )
            }
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {showHistory && (
                <CustomDialog
                    TransitionComponent={Transition}
                    title={'Hotel Booking History'}
                    maxWidth="xl"
                    handleClose={() => {
                        setShowHistory(false);
                        setHotelHistory([]);
                    }}
                    showClose={true}
                    open={showHistory}
                    fullWidth={true}
                    renderContent={renderDialogContent}
                    renderActions={renderDialogActions}
                />
            )}
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() => {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <PendingActionDialog
                    open={pendingAction.get().open}
                    message={pendingAction.get().message}
                    OkButtonText={pendingAction.get().OkButtonText}
                    handleCnfClick={() => handlePendingAction(pendingAction)}
                    onCancelClick={() => {
                        pendingAction.set({
                            ...pendingAction.get(),
                            open: false,
                        });
                        approveloading.set({
                            loading: false,
                            index: 0
                        })
                        rejectloading.set({
                            loading: false,
                            index: 0
                        })
                    }}></PendingActionDialog>
            }
            {openNoteDialog.get() && (
                <AdminNote
                    open={openNoteDialog.get()}
                    title={`${requestNote.get().action} Note`}
                    handleClose={closeNoteDialog}
                    updateNote={updateNote}
                    data={requestNote.attach(Downgraded).get()}
                />
            )}
            {
                <ConfirmationDialog
                    open={rejectConfirmation.get().open}
                    message={rejectConfirmation.get().message}
                    OkButtonText={rejectConfirmation.get().OkButtonText}
                    note={allNote}
                    allNoteValue={hanldeAllNoteValue}
                    handleCnfClick={() =>
                        handleRejectConfirmation(rejectConfirmation)
                    }
                    fullWidth={true}
                    onCancelClick={() => {
                        rejectConfirmation.set({
                            ...rejectConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {openDialog.get() && (
                <HotelSettingsDialog
                    open={openDialog.get()}
                    title="Add Settings"
                    handleClose={handleClose}
                    users={participantList}
                    snackBarProps={props.snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                    getParticipants={getAdminHotelRequestList}
                    hotelList={true}
                    eventParticipants={
                        participantList.length > 0 ? participantList : []
                    }
                    ModuleType={2}
                />
            )}
            {
                <ConfirmationDialog
                    open={approveConfirmation.get().open}
                    message={approveConfirmation.get().message}
                    OkButtonText={approveConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleApproveConfirmation(approveConfirmation)
                    }
                    fullWidth={true}
                    note={allNote}
                    allNoteValue={hanldeAllNoteValue}
                    onCancelClick={() => {
                        approveConfirmation.set({
                            ...approveConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
        </Box>
    );
};

export default DraftHotelBooking;